/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { ImageGalleryComponentEditor } from "./edit/index";
import { ImageGalleryComponentDisplay } from "./display/index";
import { getComponentZoneLayout } from "cms/components/components/component";

const ImageGalleryComponent = (props) => {
    
    const { ...everything } = props;
    const zoneProps = {
        ...everything,
        displayComponent: <ImageGalleryComponentDisplay />,
        editComponent: <ImageGalleryComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

ImageGalleryComponent.displayName = "ImageGalleryComponent";
export { ImageGalleryComponent };
